import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createPermission, fetchPermission, updatePermission } from '../../../api/PermissionsAPI';
import { handleApiError } from '../../../api/risapi';
import { capitalizeFirstLetter } from '../../../commonfunctions';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppToaster from '../../../components/AppToaster';

// The component now accepts props, including currentPermissionId
const PermissionsForm = ({ formType, currentPermissionId }) => {
    const navigate = useNavigate();
    const [permission, setPermission] = useState({ name: '' });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    const isEditMode = formType === 'edit';

    useEffect(() => {
        // Use the prop 'currentPermissionId' for fetching data
        if (isEditMode && currentPermissionId) {
            setIsLoading(true);
            fetchPermission(currentPermissionId, (response) => {
                setIsLoading(false);
                if (response.permission) {
                    setPermission(response.permission);
                }
            });
        }
    }, [currentPermissionId, isEditMode]); // useEffect depends on the prop now

    const handleInputChange = (e) => {
        setPermission({ ...permission, name: e.target.value });
    };

    const handleSubmit = (exitForm) => {
        setIsLoading(true);
        setErrors({});
        const apiCall = isEditMode ? updatePermission : createPermission;
        
        // The 'permission' state object will contain the id after being fetched
        apiCall(permission, (response) => {
            setIsLoading(false);
            if (response.permission) {
                const message = `Permission ${isEditMode ? 'updated' : 'created'} successfully!`;
                if (exitForm) {
                    navigate('/club_portal/permissions', { state: { message } });
                } else {
                    setToaster({ type: 'success', heading: 'Success', message });
                    setShowToaster(true);
                    setPermission({ name: '' });
                }
            } else {
                handleApiError(response, setErrors);
            }
        });
    };

    return (
        <main>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <div className="container-fluid">
                <AppBreadCrumb title={isEditMode ? 'Edit Permission' : 'Create Permission'}>
                    <li><a className="f-s-14 f-w-500" href="#">Access Control</a></li>
                    <li><a className="f-s-14 f-w-500" href="/club_portal/permissions">Permissions</a></li>
                    <li className="active"><a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a></li>
                </AppBreadCrumb>
                <div className="card">
                    <div className="card-header">
                         <h5>{isEditMode ? `Editing: ${permission.name}` : 'Permission Details'}</h5>
                    </div>
                    <div className="card-body">
                        <form className="app-form">
                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        <label className="form-label">Permission Name *</label>
                                        <input className="form-control" placeholder="e.g., create-venue" value={permission.name} name="name" onChange={handleInputChange} required type="text" />
                                        <small className="form-text text-muted">Use a descriptive, kebab-case name (e.g., edit-own-profile).</small>
                                    </div>
                                    <div className="mb-3"><span className="text-danger">{errors?.name}</span></div>
                                </div>
                                <div className="col-12 text-end">
                                    {!isEditMode ? (
                                        <>
                                            <button type="button" className="btn btn-outline-primary me-2 btn-sm" onClick={() => handleSubmit(false)}>Save + Next</button>
                                            <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)}>Save + Exit</button>
                                        </>
                                    ) : (
                                        <>
                                            <button type="button" className="btn btn-primary me-2 btn-sm" onClick={() => handleSubmit(true)} disabled={isLoading}>{isLoading ? 'Updating...' : 'Update Permission'}</button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={() => navigate('/club_portal/permissions')}>Cancel</button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PermissionsForm;

